import React, { useContext } from "react";

import { Flex, Container, Box } from "flicket-ui";
import useSWR from "swr";

import {
  Footer,
  BottomBar,
  Menu,
  Seo,
  Status,
  ContentContainer,
  SlateRenderer,
} from "~components";
import { BaseContext } from "~context";
import { getImageSrc, sdk } from "~lib";
import { Layout } from "~components/common/Layout";
import { remainingEventsForSeason } from "~lib/helpers/remainingEventsForSeason";
import { TourOverviewTile } from "~components/tours/tourOverviewTile";
import sortBy from "lodash/sortBy";
import { useAccount } from "~hooks";
import Image from "next/image";
import { ensureRichTextFormat } from "@flicket/utils";

const getSeasons = async (_: string, orgId: string) => {
  const seasons = (await sdk({ orgId }).seasons()).seasons;
  const sortedZones = sortBy(seasons, (season) => season.displayOrder ?? 0);
  return sortedZones;
};

const swrConfig = {
  shouldRetryOnError: false,
};

const Tours = () => {
  const { organization } = useContext(BaseContext);
  const { isAdmin } = useAccount();
  const { data: seasons, error: seasonsError } = useSWR(
    organization?.id ? ["seasonsOverview", organization?.id] : null,
    getSeasons,
    swrConfig
  );

  return (
    <>
      <Seo title="Tours" description="Tours" />
      <Menu />
      <Layout layoutType="main">
        <ContentContainer variant="content">
          <Flex flexDir="column" flex="1" mb={4}>
            <Container innerProps={{ minHeight: { _: 0, md: "320px" } }}>
              <Box mb={4}>
                <Box bg="white" borderColor="N200">
                  {organization?.landingTours?.banner && (
                    <Box>
                      <Image
                        src={getImageSrc(
                          organization?.landingTours?.banner,
                          ""
                        )}
                        alt={organization?.name ?? "tours banner"}
                        style={{
                          width: "100%",
                          height: "auto",
                          borderRadius: 8,
                        }}
                        quality={75}
                        width={1200}
                        height={320}
                      />
                    </Box>
                  )}
                  {organization?.landingTours?.description && (
                    <Box mt={1}>
                      <SlateRenderer
                        type="experienceSales"
                        value={ensureRichTextFormat(
                          organization?.landingTours?.description
                        )}
                      />
                    </Box>
                  )}
                </Box>
              </Box>
              <Flex flexWrap="wrap" m={"-12px" as any}>
                <Status
                  noResult={!seasons}
                  noResultText="No events on sale just, check back soon."
                  error={seasonsError}
                  loading={!seasonsError && !seasons}
                >
                  {!!seasons &&
                    seasons?.map(
                      ({
                        id,
                        name,
                        events,
                        startDate,
                        endDate,
                        thumbnail,
                        isActive,
                        description,
                      }) => {
                        const remaingEvents = remainingEventsForSeason(
                          events,
                          isAdmin
                        );

                        return (
                          isActive &&
                          remaingEvents.length > 0 && (
                            <TourOverviewTile
                              id={id}
                              name={name}
                              events={remaingEvents}
                              startDate={startDate}
                              endDate={endDate}
                              thumbnail={thumbnail}
                              description={description}
                              isAdmin={isAdmin}
                            />
                          )
                        );
                      }
                    )}
                </Status>
              </Flex>
            </Container>
          </Flex>
          <Footer />
        </ContentContainer>
      </Layout>
      <BottomBar />
    </>
  );
};

export default Tours;
